import React from 'react';
import PropTypes from 'prop-types';
import  { Oval } from 'react-loader-spinner';

const ImageLoader = ({ open = true }) => {
  if (!open) {
    return null;
  }
  return (
    <div style={{ paddingTop: '10%', paddingLeft: '40%' }}>
      <Oval height={50} width={70} color="black" secondaryColor="black" textAlign="center" />
    </div>
  );
};

ImageLoader.propTypes = {
  open: PropTypes.bool,
};

export default ImageLoader;
